import React from "react"

import globalStyles from "../../../../App.module.scss"

export default function BashArithmetic() {
    return (
        <div className={globalStyles.article}>
            <h1>Arithmetic</h1>
            <p>Bash has three overlapping ways to do integer math — they're not interchangeable.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '600px'}}>
                    <thead>
                    <tr>
                        <th>Syntax</th>
                        <th>Notes</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>result=$(( a + b ))</code></td>
                        <td>Preferred — arithmetic expansion, returns a value</td>
                    </tr>
                    <tr>
                        <td><code>(( a + b ))</code></td>
                        <td>Arithmetic evaluation for its exit status (0 if the result is non-zero) — used in
                            <code> if</code>/<code>while</code>, not for capturing a value</td>
                    </tr>
                    <tr>
                        <td><code>let "a = a + b"</code></td>
                        <td>Older builtin, needs quoting to avoid glob expansion — prefer <code>(( ))</code></td>
                    </tr>
                    <tr>
                        <td><code>expr $a + $b</code></td>
                        <td>External program, POSIX-portable but slow (forks a process) — avoid in bash-only
                            scripts</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Increment / decrement</h3>
            <pre className={globalStyles.code}>
                <code>
                    (( i++ ))<br/>
                    (( i-- ))<br/>
                    (( i += 5 ))<br/>
                    (( i **= 2 ))&nbsp;&nbsp;<span style={{opacity: 0.7}}># exponent</span>
                </code>
            </pre>

            <h3>Common operators</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '400px'}}>
                    <thead>
                    <tr>
                        <th>Operator</th>
                        <th>Meaning</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>+ - * /</code></td>
                        <td>Add, subtract, multiply, integer divide</td>
                    </tr>
                    <tr>
                        <td><code>%</code></td>
                        <td>Modulo</td>
                    </tr>
                    <tr>
                        <td><code>**</code></td>
                        <td>Exponent</td>
                    </tr>
                    <tr>
                        <td><code>&amp;&amp; || !</code></td>
                        <td>Logical AND / OR / NOT</td>
                    </tr>
                    <tr>
                        <td><code>&amp; | ^ &lt;&lt; &gt;&gt;</code></td>
                        <td>Bitwise AND / OR / XOR / shift</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Non-decimal bases</h3>
            <pre className={globalStyles.code}>
                <code>
                    echo $(( 0x1F ))&nbsp;&nbsp;<span style={{opacity: 0.7}}># hex -&gt; 31</span><br/>
                    echo $(( 010 ))&nbsp;&nbsp;<span style={{opacity: 0.7}}># octal -&gt; 8</span><br/>
                    echo $(( 2#1010 ))&nbsp;&nbsp;<span style={{opacity: 0.7}}># base#value -&gt; 10</span>
                </code>
            </pre>
            <b>All bash arithmetic is integer-only</b> — for floating point, shell out to
            <code> bc</code> or <code>awk</code>, e.g. <code>echo "scale=2; 10/3" | bc</code>.
        </div>
    )
}
